const icons = {
  theme: '/static/theme.png',
  requestType: '/static/requestType.png',
  createTime: '/static/createTime.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '需求类型',
    icon: icons.requestType,
    prop: 'demandsType',
    tagList: [
      { name: '技术难题', value: '1', key: 'demandsType1' },
      { name: '产品需求', value: '2', key: 'demandsType2' },
      { name: '服务需求', value: '3', key: 'demandsType3' },
      { name: '其他需求', value: '4', key: 'demandsType4' }
      // { name: '不限', value: '', key: 'demandsType' }
    ]
  },
  {
    ...publicOptions,
    name: '发布时间',
    icon: icons.createTime,
    prop: 'searchValue',
    tagList: [
      { name: '今天', value: '1', color: '#89C997', key: 'searchValue1' },
      { name: '三天内', value: '2', color: '#89C997', key: 'searchValue2' },
      { name: '一周内', value: '3', color: '#89C997', key: 'searchValue3' },
      { name: '一个月内', value: '4', color: '#89C997', key: 'searchValue4' },
      { name: '三个月内', value: '5', color: '#89C997', key: 'searchValue5' },
      { name: '一年内', value: '6', color: '#89C997', key: 'searchValue6' }
      // { name: '不限', value: '0', color: '#6582FF', key: 'searchValue' }
    ]
  },
  {
    ...publicOptions,
    name: '发布主体',
    icon: icons.theme,
    prop: 'companyType',
    tagList: [
      { name: '国有企业', value: '1', key: 'companyType1' },
      { name: '民营企业', value: '2', key: 'companyType2' },
      { name: '个人', value: '3', key: 'companyType3' },
      { name: '其他', value: '4', key: 'companyType4' }
      // { name: '不限', value: '', key: 'companyType' }
    ]
  }
]

module.exports = {
  filterOptions
}
